module.exports = __webpack_public_path__ + "img/6-half-sm.00a04f58.jpg";